module.exports = "/_next/static/images/Hero@2x-edf75c677c6f48fe15bffec633b15110.png";